import script from "./ApiReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApiReport.vue?vue&type=script&lang=ts&setup=true"

import "./ApiReport.vue?vue&type=style&index=0&id=8e6d0c9a&scoped=true&lang=css"

import exportComponent from "/Users/barry/www/my/www/bi/portal-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e6d0c9a"]])

export default __exports__